import { Menu, Group, rem, Text, Loader, useMantineTheme } from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"
import React, { ReactElement, ReactNode } from "react"

export type InputWithMenuProps = {
  children?: ReactNode
  rightSectionIcon?: ReactNode
  items: {
    icon?: ReactElement
    label: string
    onClick?: () => void
    disabled: boolean
  }[]
  loading?: boolean
  iconStyles?: React.CSSProperties
  menuWidth: string | number
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const defaultIconStyle = {
  width: 16,
  height: 16,
  color: "var(--mantine-color-primary-4)",
}

export const InputWithMenu = ({
  children,
  items,
  rightSectionIcon,
  loading,
  iconStyles = {},
  menuWidth,
  onClick,
}: InputWithMenuProps) => {
  const theme = useMantineTheme()

  return (
    <Group wrap="nowrap" gap={0}>
      <Menu
        transitionProps={{ transition: "pop-top-right" }}
        width={menuWidth}
        withinPortal
      >
        <Menu.Target>
          <Group
            onClick={onClick}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: menuWidth,
              padding: `var(--mantine-spacing-xs) var(--mantine-spacing-xs)`,
              gap: rem(10),
              borderRadius: theme.radius.sm,
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: "white",
              cursor: "pointer",
              userSelect: "none",
              position: "relative",
            }}
            tabIndex={0}
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {children}
            <Group justify="center" align="center">
              {loading ? (
                <Loader size="sm" />
              ) : rightSectionIcon ? (
                rightSectionIcon
              ) : (
                <IconChevronDown
                  style={{ width: rem(18), height: rem(18) }}
                  stroke={1.5}
                />
              )}
            </Group>
          </Group>
        </Menu.Target>

        {items && (
          <Menu.Dropdown style={{ width: menuWidth }}>
            {items.map(({ icon, label, onClick, disabled }, index) => (
              <Menu.Item
                key={index}
                leftSection={
                  icon &&
                  React.cloneElement(icon, {
                    ...defaultIconStyle,
                    ...iconStyles,
                  })
                }
                onClick={onClick}
                disabled={disabled}
              >
                <Text size="sm">{label}</Text>
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        )}
      </Menu>
    </Group>
  )
}
